export default __webpack_public_path__ + "static/media/ts.75b799ff.svg";